import { OrgConfigPage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 机构参数（运营端本租户，门禁 sys:config:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端关闭租户维度。
 */
export default function OrgConfig() {
  return <OrgConfigPage hq={hq} />;
}
